import ReactSelectWrapper from 'components/FormUtils/ReactSelectWrapper'
import { MdSort } from 'react-icons/md'
import {
  components,
  PlaceholderProps,
  SingleValueProps,
  Props as ReactSelectProps,
} from 'react-select'

const SingleValue = (props: SingleValueProps) => (
  <components.SingleValue {...props}>
    <div className="flex items-center gap-2">
      <MdSort className="text-gray-400" size={16} />
      {props.children}
    </div>
  </components.SingleValue>
)

const Placeholder = (props: PlaceholderProps) => (
  <components.Placeholder {...props}>
    <div className="flex items-center gap-2">
      <MdSort className="text-gray-400" size={16} />
      {props.children}
    </div>
  </components.Placeholder>
)

export function SortSelect({ options, value, onChange }: ReactSelectProps) {
  return (
    <ReactSelectWrapper
      placeholder="Select Sorting..."
      options={options}
      value={value}
      components={{ SingleValue, Placeholder }}
      onChange={onChange}
      className="bg-white"
    />
  )
}
